import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.1.0-alpha';

function sql(table){
  const safe=/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(table||'')?table:'research_states';
  return [
    `alter table public.${safe} add column if not exists user_id uuid;`,
    ``,
    `alter table public.${safe} enable row level security;`,
    ``,
    `drop policy if exists "${safe}_select_own" on public.${safe};`,
    `create policy "${safe}_select_own"`,
    `on public.${safe}`,
    `for select`,
    `using (auth.uid() = user_id);`,
    ``,
    `drop policy if exists "${safe}_insert_own" on public.${safe};`,
    `create policy "${safe}_insert_own"`,
    `on public.${safe}`,
    `for insert`,
    `with check (auth.uid() = user_id);`,
    ``,
    `drop policy if exists "${safe}_update_own" on public.${safe};`,
    `create policy "${safe}_update_own"`,
    `on public.${safe}`,
    `for update`,
    `using (auth.uid() = user_id)`,
    `with check (auth.uid() = user_id);`,
    ``,
    `drop policy if exists "${safe}_delete_own" on public.${safe};`,
    `create policy "${safe}_delete_own"`,
    `on public.${safe}`,
    `for delete`,
    `using (auth.uid() = user_id);`,
    ``,
    `create index if not exists ${safe}_user_symbol_scope_idx`,
    `on public.${safe}(user_id, symbol, scope);`
  ].join('\n');
}

function attachOwner(record,userId){
  if(!record || typeof record!=='object') throw new Error('RECORD_REQUIRED');
  if(!userId) throw new Error('USER_ID_REQUIRED');
  return Object.freeze({...record,user_id:userId});
}

function verifyOwned(record,userId){
  if(!record || !userId) return Object.freeze({owned:false,reason:'MISSING_INPUT'});
  if(!record.user_id) return Object.freeze({owned:false,reason:'MISSING_OWNER'});
  if(record.user_id!==userId) return Object.freeze({owned:false,reason:'OWNER_MISMATCH'});
  return Object.freeze({owned:true,reason:'OWNER_MATCH'});
}

function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});

  const s=sql('research_states');
  ok('RLS enabled',s.includes('enable row level security'));
  ok('select policy restricted to auth.uid',s.includes('for select')&&s.includes('auth.uid() = user_id'));
  ok('insert policy checks owner',s.includes('for insert')&&s.includes('with check (auth.uid() = user_id)'));
  ok('update policy checks owner',s.includes('for update')&&s.includes('using (auth.uid() = user_id)'));
  ok('delete policy restricted to owner',s.includes('for delete')&&s.includes('auth.uid() = user_id'));
  ok('user ownership index included',s.includes('user_symbol_scope_idx'));
  ok('unsafe table falls back',sql('bad-name').includes('public.research_states'));

  const r=attachOwner({symbol:'AAA'},'u1');
  ok('attachOwner adds user id',r.user_id==='u1');
  ok('verifyOwned accepts same owner',verifyOwned(r,'u1').owned===true);
  ok('verifyOwned rejects other owner',verifyOwned(r,'u2').reason==='OWNER_MISMATCH');
  ok('verifyOwned rejects missing owner',verifyOwned({symbol:'AAA'},'u1').reason==='MISSING_OWNER');

  let err=false;
  try{attachOwner({symbol:'AAA'},null)}catch(e){err=e.message==='USER_ID_REQUIRED'}
  ok('attachOwner requires user id',err===true);

  ok('no trade signal',!('tradeSignal' in r));
  ok('no capital permission',!('capitalPermission' in r));

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

const API={VERSION,sql,attachOwner,verifyOwned,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestSupabaseRLSOwnershipContract=Object.freeze(API);
})(engineContext);